import { useEffect, useState } from 'react'
import { AssetGroup } from '../types'
import { getAssetGroup, getAssetGroups } from '../services/assetGroup'

export function useAssetGroups() {
  const [assetGroups, setAssetGroups] = useState<AssetGroup[]>([])

  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    const controller = new AbortController()

    loadAssetGroups(controller)

    return () => controller.abort()
  }, [])

  async function loadAssetGroups(controller: AbortController) {
    try {
      setLoading(true)
      setAssetGroups(await getAssetGroups({ signal: controller.signal }))
    } catch {
      // We can ignore the error.
    } finally {
      setLoading(false)
    }
  }

  return {
    assetGroups,
    loading
  }
}

export function useAssetGroupLoader(id?: string | null) {
  const [assetGroup, setAssetGroup] = useState<AssetGroup | null>(null)

  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    if (id) {
      const controller = new AbortController()

      loadAssetGroup(id, controller)

      return () => controller.abort()
    }
  }, [id])

  async function loadAssetGroup(id: string, controller: AbortController) {
    try {
      setLoading(true)

      setAssetGroup(await getAssetGroup(id, { signal: controller.signal }))
    } catch {
      // We can ignore the error.
    } finally {
      setLoading(false)
    }
  }

  return {
    assetGroup,
    loading
  }
}
